var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDPETROLPRICES = CONFUSEDPETROLPRICES || {};
CONFUSEDPETROLPRICES.Maps = CONFUSEDPETROLPRICES.Maps || {};

(function (ns, $) {
    'use strict';

    CONFUSEDPETROLPRICES.initDirectionsMap = function () {
        // initialise map
        return new google.maps.Map(document.getElementById('map'));
    };

    CONFUSEDPETROLPRICES.initDirectionsRenderer = function () {
        // initialise renderer
        return new google.maps.DirectionsRenderer();
    };

    CONFUSEDPETROLPRICES.renderDirections = function (postcodeLat, postcodeLng, priceLat, priceLng, map, renderer) {

        // set coordinates
        var postcodeCoord = { lat: postcodeLat, lng: postcodeLng };
        var stationCoord = { lat: priceLat, lng: priceLng };

        // set map
        map.setOptions({ zoom: 7, center: postcodeCoord });

        // set renderer
        renderer.setMap(map);
        renderer.setPanel(document.getElementById('directionsPanel'));

        // directions service
        var directionsService = new google.maps.DirectionsService();
        directionsService.route({
            origin: postcodeCoord,
            destination: stationCoord,
            travelMode: google.maps.TravelMode.DRIVING,
            provideRouteAlternatives: true,
            unitSystem: google.maps.UnitSystem.IMPERIAL
        }, function (response, status) {

            if (status === google.maps.DirectionsStatus.OK) {

                // log directions 'permitted'
                CONFUSEDPETROLPRICES.submitPageEvent({
                    EventType: 'petrolprices:directions:permitted', EventInfo: { 'Status': status }
                });

                // render
                renderer.setDirections(response);

            } else {

                // log directions 'not permitted'
                CONFUSEDPETROLPRICES.submitPageEvent({
                    EventType: 'petrolprices:directions:notpermitted', EventInfo: { 'Status': status }
                });
            }
        });
    };

}(CONFUSEDPETROLPRICES.Maps, jQuery));